import { Slot } from "@radix-ui/react-slot";
import type { ComponentPropsWithoutRef } from "react";
import { cn } from "@repo/blacksmith-ui/cn";

export const CHAT_CARD_CLASS =
  "rounded-lg bg-[var(--color-surface-inset)] px-3 py-3";
export const CHAT_CARD_INTERACTIVE_CLASS =
  "cursor-pointer transition-colors duration-0 hover:bg-[var(--color-surface-inset-hover)]";

type ChatCardProps = ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
  interactive?: boolean;
};

export function ChatCard({
  asChild,
  interactive,
  className,
  ...props
}: ChatCardProps) {
  const Comp = asChild ? Slot : "div";
  return (
    <Comp
      className={cn(
        CHAT_CARD_CLASS,
        interactive && CHAT_CARD_INTERACTIVE_CLASS,
        className,
      )}
      {...props}
    />
  );
}
